import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";
import type { ICountryObject } from "app/services/CountryService";
import type { CountryVisitsShare, CountryVisitsSharesByCountryId, CountryWithTrafficShare } from "../types/countries";
import type { WebSourceId } from "../types/common";

export const hasDesktopTrafficSource = createTrafficSourcePredicate("Desktop");

export const hasMobileTrafficSource = createTrafficSourcePredicate("MobileWeb");

export function isWorldwideCountry(country: ICountryObject) {
    return country.id === WORLDWIDE_COUNTRY_ID;
}

export function getCountryName<T extends ICountryObject>(country: T) {
    return country.text;
}

function createTrafficSourcePredicate(source: WebSourceId) {
    return function hasTrafficSource(country: CountryWithTrafficShare) {
        return country.trafficSource === source;
    };
}

export function toCountriesVisitsSharesByCountryId(countriesVisitsShares: readonly CountryVisitsShare[]) {
    return countriesVisitsShares.reduce<CountryVisitsSharesByCountryId>((map, countryVisitsShare) => {
        map[countryVisitsShare.country] = countryVisitsShare;

        return map;
    }, {});
}

export function mergeCountriesWithTrafficShare(
    countries: readonly ICountryObject[],
    countriesVisitsSharesByCountryId: Readonly<CountryVisitsSharesByCountryId>,
): CountryWithTrafficShare[] {
    return countries.map((c) => {
        const countryVisitsShare = countriesVisitsSharesByCountryId[c.id];

        return {
            ...c,
            trafficShare: countryVisitsShare?.share ?? 0,
            trafficSource: countryVisitsShare?.trafficSource,
        };
    });
}

export function getCountriesButtonText(selectedCountries: readonly ICountryObject[]) {
    const numberOfSelectedCountries = selectedCountries.length;

    if (numberOfSelectedCountries === 0) {
        return "";
    }

    if (numberOfSelectedCountries === 1) {
        return selectedCountries[0].text;
    }

    return `${selectedCountries[0].text} +${numberOfSelectedCountries - 1}`;
}
